<template>
  <div class="stats-audit-formula-form">
    <div class="sa-ff-tabs-box">
      <div class="sa-ff-tabs-head">
        <el-input
          placeholder="请输入内容"
          v-model="search"
          class="sa-ff-tabs-head-input"
          @change="getAuditFormulaList"
        >
          <el-button
            slot="append"
            icon="el-icon-plus"
            @click.stop="addAuditFormula()"
          ></el-button>
        </el-input>
      </div>
      <el-tabs
        v-loading="listLoading"
        v-model="acAuditTabName"
        class="sa-ff-tabs"
        type="border-card"
        tab-position="left"
        @tab-click="errorMaps={}"
      >
        <el-tab-pane
          v-for="audit in auditFormulaTabsList"
          :key="audit._id||audit.$hash"
          :label="audit.label"
          :name="audit._id||audit.$hash"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="sa-ff-main">
      <div class="sa-ff-main-box">
        <div class="sa-ff-main-base">
          <div class="sa-ff-from-title">基础信息</div>
          <div class="sa-ff-from-box">
            <el-form
              ref="form"
              :model="acAuditFormulaForm"
              label-width="160px"
            >
              <el-row :gutter="20">
                <el-col
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="公式标识"
                    :error="errorMaps[getItemKey('flag')]"
                  >
                    <el-input v-model="acAuditFormulaForm[getItemKey('flag')]"></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="公式中文名称"
                    :error="errorMaps[getItemKey('name')]"
                  >
                    <el-input v-model="acAuditFormulaForm[getItemKey('name')]"></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="公式英文名称"
                    :error="errorMaps[getItemKey('english_name')]"
                  >
                    <el-input v-model="acAuditFormulaForm[getItemKey('english_name')]"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    class="is-required"
                    label="公式类型"
                    :error="errorMaps[getItemKey('types')]"
                  >
                    <el-radio-group v-model="acAuditFormulaForm[getItemKey('types')].value">
                      <el-radio
                        v-for="item in getInitDict('types',[])"
                        :key="item.value"
                        :label="item.value"
                      >
                        {{item.text}}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="状态"
                    :error="errorMaps[getItemKey('status')]"
                  >
                    <el-radio-group v-model="acAuditFormulaForm[getItemKey('status')].value">
                      <el-radio
                        v-for="item in getInitDict('status',[])"
                        :key="item.value"
                        :label="item.value"
                      >
                        {{item.text}}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-show="acAuditFormulaForm[getItemKey('types')].value==2"
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="子表名称"
                    :error="errorMaps[getItemKey('sub_table')]"
                  >
                    <el-select
                      v-model="acAuditFormulaForm[getItemKey('sub_table')].value"
                      placeholder="请选择"
                      @change="selectChange('sub_table')"
                    >
                      <el-option
                        v-for="item in getInitDict('sub_table',[])"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="统计公式用途"
                    :error="errorMaps[getItemKey('used')]"
                  >
                    <el-select
                      v-model="acAuditFormulaForm[getItemKey('used')].value"
                      placeholder="请选择"
                      @change="selectChange('used')"
                    >
                      <el-option
                        v-for="item in getInitDict('used',[])"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="统计公式审核方式"
                    :error="errorMaps[getItemKey('audit_method')]"
                  >
                    <el-select
                      v-model="acAuditFormulaForm[getItemKey('audit_method')].value"
                      placeholder="请选择"
                      @change="selectChange('audit_method')"
                    >
                      <el-option
                        v-for="item in getInitDict('audit_method',[])"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="统计公式权限"
                    :error="errorMaps[getItemKey('permission')]"
                  >
                    <el-select
                      v-model="acAuditFormulaForm[getItemKey('permission')].value"
                      placeholder="请选择"
                      @change="selectChange('permission')"
                    >
                      <el-option
                        v-for="item in getInitDict('permission',[])"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :lg="6"
                  :sm="8"
                >
                  <el-form-item
                    class="is-required"
                    label="统计公式强制性类型"
                    :error="errorMaps[getItemKey('mandatory_type')]"
                  >
                    <el-select
                      v-model="acAuditFormulaForm[getItemKey('mandatory_type')].value"
                      placeholder="请选择"
                      @change="selectChange('mandatory_type')"
                    >
                      <el-option
                        v-for="item in getInitDict('mandatory_type',[])"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    class="is-required"
                    label="错误提示"
                    :error="errorMaps[getItemKey('hint')]"
                  >
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="acAuditFormulaForm[getItemKey('hint')]"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="sa-ff-from-title">审核编辑</div>
        <div class="sa-ff-main-top">
          <div class="sa-ff-code-edit">
            <DsfDmPythonEditor
              ref="editor"
              :editText="acAuditFormulaForm[getItemKey('content')]"
              theme="vs"
              @editLoaded="handleEditMounted"
            ></DsfDmPythonEditor>
          </div>
          <div class="sa-ff-report-box">
            <DsfViewPart
              ref="reportForm"
              class="sa-ff-report-viewpart"
              path="t/2023/B/form?isview=1&hash=LcNw1sLymkkdqcKn"
              @ready="initProxyReportFormItems"
            >
            </DsfViewPart>
          </div>
        </div>
      </div>
      <div class="sa-ff-main-bottom">
        <DsfButton>验证</DsfButton>
        <DsfButton @click="save">保存</DsfButton>
        <DsfButton
          @click="closePage"
          type="plain"
        >取消</DsfButton>
      </div>
    </div>
  </div>
</template>

<script>
const initPrefix = "dsfa_formula";
function getDefaultAcAuditFormulaForm() {
  return {
    $hash: dsf.uuid(),
    [initPrefix + ".flag"]: "",
    [initPrefix + ".name"]: "",
    [initPrefix + ".english_name"]: "",
    [initPrefix + ".content"]: "",
    [initPrefix + ".business_id"]: "",
    [initPrefix + ".hint"]: "",
    [initPrefix + ".types"]: {
      text: "",
      value: "",
    },
    [initPrefix + ".used"]: {
      text: "",
      value: "",
    },
    [initPrefix + ".audit_method"]: {
      text: "",
      value: "",
    },
    [initPrefix + ".permission"]: {
      text: "",
      value: "",
    },
    [initPrefix + ".mandatory_type"]: {
      text: "",
      value: "",
    },
    [initPrefix + ".status"]: {
      text: "",
      value: "",
    },
    [initPrefix + ".source"]: {
      text: "",
      value: "",
    },
    [initPrefix + ".sub_table"]: {
      text: "",
      value: "",
    },
  };
}
export default dsf.component({
  name: "DsfStatsAuditFormulaForm",
  ctrlCaption: "审核公式维护",
  data() {
    return {
      search: "",
      auditFormulaList: [],
      initData: {},
      initPrefix,
      acAuditTabName: null,
      nameSpace: "dsfa.formula",
      pageName: "edit",
      addAuditFormulaList: [],
      errorMaps: {},
      listLoading: false,
    };
  },
  computed: {
    acAuditFormulaForm() {
      return (
        this.auditFormulaList.find((ite) => {
          return (
            ite._id == this.acAuditTabName || ite.$hash == this.acAuditTabName
          );
        }) ||
        this.addAuditFormulaList.find((ite) => {
          return ite.$hash == this.acAuditTabName;
        }) ||
        getDefaultAcAuditFormulaForm()
      );
    },
    auditFormulaTabsList() {
      return this.auditFormulaList
        .map((ite) => {
          return {
            _id: ite._id,
            $hash: ite.$hash,
            label: ite["name"],
          };
        })
        .concat(
          this.addAuditFormulaList.map((ite) => {
            return {
              _id: ite._id,
              $hash: ite.$hash,
              label: ite[this.getItemKey("name")],
            };
          })
        );
    },
  },
  watch: {
    auditFormulaList: {
      immediate: true,
      handler(list) {
        _.each(list, (ite, i) => {
          this.$set(ite, "$order", i);
        });
      },
    },
  },
  methods: {
    addAuditFormula() {
      const defaultData = {
        [initPrefix + ".name"]: "公式名称",
      };
      const statusOptions = this.getInitDict("status", []);
      if (statusOptions.length) {
        defaultData[initPrefix + ".status"] = {
          text: statusOptions[0].text,
          value: statusOptions[0].value,
        };
      }
      const typesOptions = this.getInitDict("types", []);
      if (typesOptions.length) {
        defaultData[initPrefix + ".types"] = {
          text: typesOptions[0].text,
          value: typesOptions[0].value,
        };
      }
      const node = Object.assign(getDefaultAcAuditFormulaForm(), defaultData);
      this.addAuditFormulaList.push(node);
      this.acAuditTabName = node.$hash;
    },
    getItemKey(name) {
      return this.initPrefix + "." + name;
    },
    getInitDict(name, defaultVal) {
      return this.initData?.[this.getItemKey(name)]?.dataSource || defaultVal;
    },
    getInit() {
      dsf.http
        .get("/meta/init", {
          pageName: this.pageName,
          namespace: this.nameSpace,
        })
        .done((data) => {
          this.initData = data.data || {};
          this.getSubTable();
        });
    },
    handleEditMounted() {},
    validate() {
      const getItemKey = this.getItemKey;
      const acAuditFormulaForm = this.acAuditFormulaForm;
      const errorMaps = {};
      if (!acAuditFormulaForm[getItemKey("flag")]) {
        errorMaps[getItemKey("flag")] = "请输入公式标识";
      }
      if (!acAuditFormulaForm[getItemKey("name")]) {
        errorMaps[getItemKey("name")] = "请输入公式中文名称";
      }
      if (!acAuditFormulaForm[getItemKey("english_name")]) {
        errorMaps[getItemKey("english_name")] = "请输入公式英文名称";
      }
      if (!acAuditFormulaForm[getItemKey("types")]?.value) {
        errorMaps[getItemKey("types")] = "请选择公式类型";
      }
      if (
        acAuditFormulaForm[getItemKey("types")].value == 2 &&
        !acAuditFormulaForm[getItemKey("sub_table")]?.value
      ) {
        errorMaps[getItemKey("sub_table")] = "请选择子表名称";
      }
      if (!acAuditFormulaForm[getItemKey("used")]?.value) {
        errorMaps[getItemKey("used")] = "请选择统计公式用途";
      }
      if (!acAuditFormulaForm[getItemKey("permission")]?.value) {
        errorMaps[getItemKey("permission")] = "请选择统计公式权限";
      }
      if (!acAuditFormulaForm[getItemKey("audit_method")]?.value) {
        errorMaps[getItemKey("audit_method")] = "请选择统计公式审核方式";
      }
      if (!acAuditFormulaForm[getItemKey("mandatory_type")]?.value) {
        errorMaps[getItemKey("mandatory_type")] = "请选择统计公式强制性类型";
      }
      if (!acAuditFormulaForm[getItemKey("hint")]) {
        errorMaps[getItemKey("hint")] = "请输入错误提示";
      }
      this.errorMaps = errorMaps;
      return Object.keys(this.errorMaps).length > 0;
    },
    save(e) {
      this.$set(
        this.acAuditFormulaForm,
        this.getItemKey("content"),
        this.$refs.editor.getValue() || ""
      );
      const acAuditFormulaForm = this.acAuditFormulaForm;
      const msg = this.validate();
      if (msg) {
        dsf.layer.message("请检查数据是否填写完整", false);
        return;
      }
      if (!acAuditFormulaForm[this.getItemKey("business_id")]) {
        acAuditFormulaForm[this.getItemKey("business_id")] =
          this.$route.query.bid;
      }
      const params = {
        namespace: this.nameSpace,
        pageName: this.pageName,
        data: JSON.stringify(acAuditFormulaForm),
        attach: JSON.stringify({}),
      };
      let qs = dsf.url.queryStringStringify(this.queryString);
      let url = `/meta/persistData${qs ? "?" + qs : ""}`;
      let loading = dsf.layer.loading();
      dsf.http
        .post(url, params)
        .done((data) => {
          dsf.layer.message("保存成功");
          let index = this.addAuditFormulaList.findIndex((ite) => {
            return acAuditFormulaForm.$hash == ite.$hash;
          });
          if (index >= 0) {
            this.addAuditFormulaList.splice(index, 1);
          }
          this.acAuditTabName = data?.data?._id;
          this.getAuditFormulaList();
          const vm = window?.opener?.openerVms?.[window.name];
          if (vm && vm.$page) {
            vm.$page.reloadData();
          }
        })
        .finally(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    getAuditFormulaList() {
      this.listLoading = true;
      dsf.http
        .get("/formula/queryListByBusiness", {
          pageNum: 1,
          pageSize: 20000,
          keywords: this.search,
          source: this.$route.query.source || "",
          businessId: this.$route.query.bid || "",
          namespace: this.nameSpace,
          pageName: this.pageName,
        })
        .done((data) => {
          if (data.success) {
            this.auditFormulaList.length = 0;
            this.auditFormulaList.push(...(data.data || []));
            if (!this.isEdit && !this.addAuditFormulaList.length) {
              this.addAuditFormula();
            }
            if (this.isEdit) {
              this.isEdit = false;
            }
          } else {
            dsf.layer.message(data.message, false);
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    getSubTable() {
      dsf.http
        .get("/formula/getTableInfo", {
          namespace: this.$route.query.n,
          pageName: this.$route.query.p,
        })
        .done((data) => {
          this.initData[this.getItemKey("sub_table")] = {
            dataSource: (data.data.subTable || []).map((ite) => {
              return {
                value: ite.code,
                text: ite.name,
              };
            }),
          };
        })
        .finally(() => {});
    },
    selectChange(key) {
      let list = this.getInitDict(key, []);
      let value = this.acAuditFormulaForm[this.getItemKey(key)].value;
      let node = list.find((ite) => {
        return ite.value == value;
      });
      if (node) this.acAuditFormulaForm[this.getItemKey(key)].text = node.text;
    },
    closePage() {
      window.close();
    },
    initProxyReportFormItems() {
      const _this = this;
      const reportForm = this.$refs.reportForm;
      setTimeout(() => {
        const reportFormDom = $(reportForm.$el);

        const subTables = reportFormDom.find('[report-sub="true"]');
        subTables.each(function () {
          const vm = this.__vue__;
          if (!vm?.value?.length) {
            vm.pushRow({});
          }
        });
        setTimeout(() => {
          const items = reportFormDom.find(".ds-form-item");
          items.each(function () {
            const proxyDiv = $(
              '<div class="ds-form-item-proxy" title="双击复制审核代码"></div>'
            );
            $(this)
              .css({
                position: "relative",
              })
              .append(proxyDiv);
          });
        }, 1000);
        reportFormDom.on("dblclick", function (e) {
          if ($(e.target).hasClass("ds-form-item-proxy")) {
            const vm = $(e.target).parent()[0].__vue__;
            if (vm?.metadata) {
              let text;
              if (vm.metadata.level == 1) {
                text = `row.${vm.metadata.code}`;
                copyText();
              } else {
                text = `main.${vm.metadata.code}`;
              }
              if (text) {
                _this.$refs.editor.addCode(text);
                dsf.layer.message(`【${text}】代码已插入到编辑器中`);
              }
            }
          }
        });
      }, 1000);
    },
  },
  created() {
    if (this.$route.query.id) {
      this.isEdit = true;
      this.acAuditTabName = this.$route.query.id;
    }
    this.getAuditFormulaList();
    this.getInit();
  },
  mounted() {},
  design: {
    isMask: true,
    fit: true,
    settingButton: true,
  },
});
function copyText(text) {
  var input = document.createElement("input");
  input.setAttribute("id", "input_for_copyText");
  input.value = text;
  document.getElementsByTagName("body")[0].appendChild(input);
  document.getElementById("input_for_copyText").select();
  document.execCommand("copy");
  document.getElementById("input_for_copyText").remove();
}
</script>